import React, { useState } from 'react';
import './VideoPlaylist.scss';
import brand1 from '../../brand1.svg';

const VideoPlaylist = () => {
  const [playingVideo, setPlayingVideo] = useState(null);
  const [playingCarouselVideos, setPlayingCarouselVideos] = useState({});
  const [fullscreenVideo, setFullscreenVideo] = useState(null);
  
  // Main featured video
  const featuredVideo = {
    id: 1,
    title: "About Organic Greens Hub",
    description: "Learn about our mission to provide fresh, organic produce",
    thumbnail: brand1,
    videoUrl: "https://youtu.be/KXIdNIouwHY",
    videoId: "KXIdNIouwHY",
    category: "About Us"
  };
  
  // Additional videos for carousel
  const carouselVideos = [
    {
      id: 2,
      title: "Immunity Shot - The Golden Cube",
      description: "Learn about our organic products and services",
      thumbnail: "https://img.youtube.com/vi/vuvnLm7Fc8k/hqdefault.jpg",
      fallbackThumbnail: brand1,
      videoUrl: "https://www.youtube.com/watch?v=vuvnLm7Fc8k",
      videoId: "vuvnLm7Fc8k",
      category: "About Us"
    },
    {
      id: 3,
      title: "Immunity Shot - The Fireball Shot",
      description: "Discover the benefits of organic living",
      thumbnail: "https://img.youtube.com/vi/r1sz26k4ijo/hqdefault.jpg",
      fallbackThumbnail: brand1,
      videoUrl: "https://www.youtube.com/watch?v=r1sz26k4ijo",
      videoId: "r1sz26k4ijo",
      category: "Health Benefits"
    },
    {
      id: 4,
      title: "Immunity Shot - The Ruby Cube",
      description: "Fresh organic produce for healthy living",
      thumbnail: "https://img.youtube.com/vi/voJw_HDeMko/hqdefault.jpg",
      fallbackThumbnail: brand1,
      videoUrl: "https://www.youtube.com/watch?v=voJw_HDeMko",
      videoId: "voJw_HDeMko",
      category: "Products"
    },
    {
      id: 5,
      title: "Smoothie - The Glucose Guard",
      description: "Latest updates from Organic Greens Hub",
      thumbnail: "https://img.youtube.com/vi/EVFiCWIv3w4/hqdefault.jpg",
      fallbackThumbnail: brand1,
      videoUrl: "https://www.youtube.com/watch?v=EVFiCWIv3w4",
      videoId: "EVFiCWIv3w4",
      category: "Updates"
    },
    {
      id: 6,
      title: "Smoothie - The Berry Banana Boost",
      description: "Discover more about our organic journey",
      thumbnail: "https://img.youtube.com/vi/TMZMZYAQ8Ko/hqdefault.jpg",
      fallbackThumbnail: brand1,
      videoUrl: "https://www.youtube.com/watch?v=TMZMZYAQ8Ko",
      videoId: "TMZMZYAQ8Ko",
      category: "Journey"
    },
    {
      id: 7,
      title: "Smoothie - The Green Power House",
      description: "Explore our Green Power House",
      thumbnail: "https://img.youtube.com/vi/xYrPL8v6pS8/hqdefault.jpg",
      fallbackThumbnail: brand1,
      videoUrl: "https://www.youtube.com/watch?v=xYrPL8v6pS8",
      videoId: "xYrPL8v6pS8",
      category: "Premium"
    }
  ];

  const playVideo = (video) => {
    setPlayingVideo(video);
  };

  const playCarouselVideo = (video) => {
    // Open video in fullscreen modal
    setFullscreenVideo(video);
  };

  const closeFullscreenVideo = () => {
    setFullscreenVideo(null);
  };

  const scrollCarousel = (direction) => {
    const carousel = document.querySelector('.video-carousel');
    const scrollAmount = 300;
    if (direction === 'left') {
      carousel.scrollLeft -= scrollAmount;
    } else {
      carousel.scrollLeft += scrollAmount;
    }
  };

  return (
    <div className="video-playlist-section">
      {/* Fullscreen Video Modal */}
      {fullscreenVideo && (
        <div className="fullscreen-modal" onClick={closeFullscreenVideo}>
          <div className="fullscreen-content" onClick={(e) => e.stopPropagation()}>
            <button className="close-btn" onClick={closeFullscreenVideo}>
              ×
            </button>
            <iframe
              width="100%"
              height="100%"
              src={`https://www.youtube.com/embed/${fullscreenVideo.videoId}?autoplay=1&rel=0`}
              title={fullscreenVideo.title}
              frameBorder="0"
              allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
              allowFullScreen
            ></iframe>
          </div>
        </div>
      )}
      
      <div className="container">
        <h2>About Organic Living</h2>
        <p className="section-subtitle">Discover the benefits of organic products and healthy living</p>
        
        {/* Featured Video */}
        <div className="featured-video">
          <div className="video-card">
            {playingVideo ? (
              <div className="video-player">
                <iframe
                  width="100%"
                  height="400"
                  src={`https://www.youtube.com/embed/${playingVideo.videoId}?autoplay=1&rel=0`}
                  title={playingVideo.title}
                  frameBorder="0"
                  allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                  allowFullScreen
                ></iframe>
              </div>
            ) : (
              <div className="video-thumbnail" onClick={() => playVideo(featuredVideo)}>
                <img src={featuredVideo.thumbnail} alt={featuredVideo.title} />
                <div className="play-button">
                  <svg viewBox="0 0 24 24" fill="currentColor">
                    <path d="M8 5v14l11-7z"/>
                  </svg>
                </div>
                <div className="video-category">{featuredVideo.category}</div>
              </div>
            )}
            <div className="video-info">
              <h3>{playingVideo ? playingVideo.title : featuredVideo.title}</h3>
              <p>{playingVideo ? playingVideo.description : featuredVideo.description}</p>
            </div>
          </div>
        </div>
        
        {/* Video Carousel */}
        <div className="video-carousel-section">
          <div className="carousel-header">
            <h3>More Videos</h3>
            <div className="carousel-controls">
              <button className="carousel-btn" onClick={() => scrollCarousel('left')}>
                <svg viewBox="0 0 24 24" fill="currentColor">
                  <path d="M15.41 7.41L14 6l-6 6 6 6 1.41-1.41L10.83 12z"/>
                </svg>
              </button>
              <button className="carousel-btn" onClick={() => scrollCarousel('right')}>
                <svg viewBox="0 0 24 24" fill="currentColor">
                  <path d="M10 6L8.59 7.41 13.17 12l-4.58 4.59L10 18l6-6z"/>
                </svg>
              </button>
            </div>
          </div>
          <div className="video-carousel">
            {carouselVideos.map(video => (
              <div key={video.id} className="carousel-video-card">
                <div className="carousel-thumbnail" onClick={() => playCarouselVideo(video)}>
                  <img 
                    src={video.thumbnail} 
                    alt={video.title}
                    onError={(e) => {
                      e.target.src = video.fallbackThumbnail;
                    }}
                  />
                  <div className="carousel-play-button">
                    <svg viewBox="0 0 24 24" fill="currentColor">
                      <path d="M8 5v14l11-7z"/>
                    </svg>
                  </div>
                </div>
                <div className="carousel-video-info">
                  <h4>{video.title}</h4>
                  <p>{video.description}</p>
                </div>
              </div>
            ))}
          </div>
        </div>
        
        <div className="view-all-videos">
          <button className="btn-secondary" onClick={() => window.open('https://www.youtube.com/@OrganicGreensHub', '_blank')}>
            View All Videos (6 videos)
          </button>
        </div>
        
        <div className="social-media-section">
          <h3>Follow Us</h3>
          <div className="social-icons">
            <button 
              className="social-icon youtube" 
              onClick={() => window.open('https://www.youtube.com/@OrganicGreensHub', '_blank')}
              title="YouTube"
            >
              <svg viewBox="0 0 24 24" fill="currentColor">
                <path d="M23.498 6.186a3.016 3.016 0 0 0-2.122-2.136C19.505 3.545 12 3.545 12 3.545s-7.505 0-9.377.505A3.017 3.017 0 0 0 .502 6.186C0 8.07 0 12 0 12s0 3.93.502 5.814a3.016 3.016 0 0 0 2.122 2.136c1.871.505 9.376.505 9.376.505s7.505 0 9.377-.505a3.015 3.015 0 0 0 2.122-2.136C24 15.93 24 12 24 12s0-3.93-.502-5.814zM9.545 15.568V8.432L15.818 12l-6.273 3.568z"/>
              </svg>
            </button>
            <button 
              className="social-icon instagram" 
              onClick={() => window.open('https://www.instagram.com/organic_greens_hub', '_blank')}
              title="Instagram"
            >
              <svg viewBox="0 0 24 24" fill="currentColor">
                <path d="M12 2.163c3.204 0 3.584.012 4.85.07 3.252.148 4.771 1.691 4.919 4.919.058 1.265.069 1.645.069 4.849 0 3.205-.012 3.584-.069 4.849-.149 3.225-1.664 4.771-4.919 4.919-1.266.058-1.644.07-4.85.07-3.204 0-3.584-.012-4.849-.07-3.26-.149-4.771-1.699-4.919-4.92-.058-1.265-.07-1.644-.07-4.849 0-3.204.013-3.583.07-4.849.149-3.227 1.664-4.771 4.919-4.919 1.266-.057 1.645-.069 4.849-.069zm0-2.163c-3.259 0-3.667.014-4.947.072-4.358.2-6.78 2.618-6.98 6.98-.059 1.281-.073 1.689-.073 4.948 0 3.259.014 3.668.072 4.948.2 4.358 2.618 6.78 6.98 6.98 1.281.058 1.689.072 4.948.072 3.259 0 3.668-.014 4.948-.072 4.354-.2 6.782-2.618 6.979-6.98.059-1.28.073-1.689.073-4.948 0-3.259-.014-3.667-.072-4.947-.196-4.354-2.617-6.78-6.979-6.98-1.281-.059-1.69-.073-4.949-.073zm0 5.838c-3.403 0-6.162 2.759-6.162 6.162s2.759 6.163 6.162 6.163 6.162-2.759 6.162-6.163c0-3.403-2.759-6.162-6.162-6.162zm0 10.162c-2.209 0-4-1.79-4-4 0-2.209 1.791-4 4-4s4 1.791 4 4c0 2.21-1.791 4-4 4zm6.406-11.845c-.796 0-1.441.645-1.441 1.44s.645 1.44 1.441 1.44c.795 0 1.439-.645 1.439-1.44s-.644-1.44-1.439-1.44z"/>
              </svg>
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default VideoPlaylist;